import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-site-energy-usage-score',
	templateUrl: './site-energy-usage-score.component.html',
	styleUrls: ['./site-energy-usage-score.component.css']
})
export class SiteEnergyUsageScoreComponent {
	@Input() data = null;
	@Input() devices = null;
	@Input() selectedDaysFilter: string = '';
	@Input() selectedPeriod: string = '';
	@Input() selectedTruckType: string = '';
	@Input() hideFilters: boolean = true;
}
